import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import type { PostTransactionMessageResponse } from 'src/queries/transactionConversations/transactionConversations.models'

export type PostTransactionMessageParams = {
  transactionId: string
  body: string
  idempotencyKey: string
  signal?: AbortSignal
}

export const TRANSACTION_COMMENT_REQUEST_TIMEOUT_MS = 15_000

export const postTransactionMessage = async ({
  transactionId,
  body,
  idempotencyKey,
  signal,
}: PostTransactionMessageParams): Promise<PostTransactionMessageResponse> => {
  if (!transactionId) {
    throw new Error('Transaction conversation transactionId is required')
  }

  const requestConfig = getRequestConfig(RequestConfig.Default)

  return getResponseData(
    axios.post<PostTransactionMessageResponse>(
      `/transactions/${transactionId}/messages`,
      { body },
      {
        ...requestConfig,
        signal,
        timeout: TRANSACTION_COMMENT_REQUEST_TIMEOUT_MS,
        headers: {
          ...requestConfig.headers,
          'Idempotency-Key': idempotencyKey,
        },
      },
    ),
  )
}
